import { httpRequest } from '../../shared/lib/utils/httpClient';
import { createAcsChatApiHooks } from '@qler-view/shared_lib/src/shared/Chat/useAcsChatApiHook';

const { useGetAcsChatToken, useGetConsultChatThread } =
  createAcsChatApiHooks(httpRequest);

export { useGetAcsChatToken, useGetConsultChatThread };
